import { AnimalsAvatarsArray, BoysAvatarsArray, GenderCodes, GirlsAvatarsArray } from '../const';

export const getRandomAvatarColor = (fio: string) => {
  const colorArray = [
    '#73757E',
    '#6B758D',
    '#D9373E',
    '#DF5600',
    '#01881A',
    '#068382',
    '#2678C3',
    '#496BE8',
    '#7C58F3',
    '#B243CD',
    '#D82D77',
  ];
  const colorIndex =
    Array.from(fio)
      .map((ltr) => ltr.charCodeAt(0))
      .reduce((s, n) => s + n) % colorArray.length;

  return colorArray[colorIndex];
};

/** @deprecated Использовалась для получения системного аватара. Позже требуется удалить вместе с картинками */
export const getAvaliableAvatars = (gender: number | undefined | null) => {
  if (gender === GenderCodes.boy) return [...BoysAvatarsArray, ...AnimalsAvatarsArray];
  return [...GirlsAvatarsArray, ...AnimalsAvatarsArray];
};
